import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import * as actions from './actions';
import { PostsStoreService } from './store.service';
import { PostsService } from '@stop-counter/shared/services';
import { PostType } from '@apps/api-interfaces';

@Injectable()
export class Effects {
  constructor(
    private api: PostsService,
    private actions$: Actions,
    private self: PostsStoreService
  ) {}

  @Effect()
  loadAction$ = this.actions$.pipe(
    ofType<actions.LoadAction>(actions.Actions.LOAD),
    map(action => action.payload),
    switchMap(async (type: PostType) => {
      return await this.api
        .getPosts(type)
        .then(res => new actions.LoadSuccessAction(res))
        .catch(error => this.handleError(error));
    })
  );

  @Effect()
  loadSingleAction$ = this.actions$.pipe(
    ofType<actions.LoadSingleAction>(actions.Actions.LOAD_SINGLE),
    map(action => action.payload),
    switchMap(async (slug: string) => {
      return await this.api
        .getPost(slug)
        .then(res => new actions.LoadSuccessAction([res]))
        .catch(error => this.handleError(error));
    })
  );

  private handleError(error) {
    return new actions.ErrorAction(error);
  }
}
